import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

// Slim, non-sticky strip that carries the subtle "launching soon" flavour.
export const AnnouncementBar = () => {
  return (
    <div className="w-full bg-halalgo-green-700 text-white" data-testid="announcement-bar">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-4 py-2 text-center text-xs font-medium sm:text-sm">
        <Sparkles className="h-4 w-4 shrink-0" />
        <span>Launching soon across the Philippines —</span>
        <Link
          to="/download"
          data-testid="announcement-waitlist-link"
          className="underline decoration-white/50 underline-offset-2 hover:decoration-white"
        >
          be the first to know
        </Link>
      </div>
    </div>
  );
};
